import type { Company } from '@/types/api'

import { apiClient } from '@/lib/api/client'
import { companyListSchema, companySchema } from '@/lib/api/schemas'

export function listCompanies(): Promise<Company[]> {
  return apiClient.requestValidated('/companies', companyListSchema)
}

export interface CreateCompanyInput {
  name: string
  mission: string
  slug?: string
}

export function createCompany(input: CreateCompanyInput): Promise<Company> {
  return apiClient.requestValidated('/companies', companySchema, {
    method: 'POST',
    body: JSON.stringify(input),
  })
}

export interface UpdateCompanyInput {
  name?: string
  mission?: string
  slug?: string
}

export function updateCompany(
  companyId: string,
  patch: UpdateCompanyInput,
): Promise<Company> {
  return apiClient.requestValidated(
    `/companies/${encodeURIComponent(companyId)}`,
    companySchema,
    { method: 'PATCH', body: JSON.stringify(patch) },
  )
}

export function deleteCompany(companyId: string): Promise<void> {
  return apiClient.request(`/companies/${encodeURIComponent(companyId)}`, {
    method: 'DELETE',
  })
}

export function exportCompany(companyId: string): Promise<unknown> {
  return apiClient.request(`/companies/${encodeURIComponent(companyId)}/export`, {
    method: 'POST',
  })
}

export function importCompany(payload: unknown): Promise<Company> {
  return apiClient.requestValidated('/companies/import', companySchema, {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export interface QualifyCompanyResponse {
  ok: boolean
  task_id: string
  company_name: string
}

export function qualifyCompany(companyId: string): Promise<QualifyCompanyResponse> {
  return apiClient.request<QualifyCompanyResponse>(
    `/companies/${encodeURIComponent(companyId)}/qualify`,
    { method: 'POST' },
  )
}
